export const CTYPE_COMP_GROUP = 'componentGroup';
export const CTYPE_FOOTER_LINK = 'footerLinks';
export const CTYPE_PAGE = 'page';
